// components
import { Translation } from 'components/Translation/Translation';
import SocialShareView from './SocialShareView';

type SocialShareProps = {
  contentType: 'page' | 'video';
  metaData: MetaData;
  productPage?: boolean;
  hashtags?: string[];
  useInContentPage?: boolean;
  isGddsLightbox?: boolean;
};

export default function SocialShare({
  productPage = false,
  hashtags = [],
  metaData,
  contentType = 'page',
  useInContentPage,
  isGddsLightbox = false,
}: Readonly<SocialShareProps>) {
  return (
    <SocialShareView
      useInContentPage={useInContentPage}
      hashtags={hashtags}
      metaData={metaData}
      contentType={contentType}
      isGddsLightbox={isGddsLightbox}
      headline={
        <Translation
          id={productPage ? 'web20_social_share_headline_product' : 'web20_social_share_headline'}
        />
      }
    />
  );
}
